(() => {
 if(window.ATELIER_COLLECTION_BAR){window.ATELIER_COLLECTION_BAR.mount(document);return;}
 let active=null;
 function cleanup(){
  if(!active)return;
  active.observer?.disconnect();
  window.removeEventListener('resize',active.update);
  window.removeEventListener('scroll',active.update);
  active.bar.classList.remove('atelier-collection-bar-fixed');
  active.bar.style.top='';
  active.parent.insertBefore(active.bar,active.next);
  active.space.remove();
  active=null;
 }
 function mount(root){
  const bar=root.querySelector('.atelier-header-wrap .preview-bar');if(!bar)return;if(active?.bar===bar){active.update();return;}
  cleanup();
  const parent=bar.parentNode,next=bar.nextSibling,header=parent.querySelector('.header');
  const space=document.createElement('div');space.className='atelier-collection-bar-space';space.setAttribute('aria-hidden','true');
  bar.before(space);bar.classList.add('atelier-collection-bar-fixed');
  let currentAnchor;
  const update=()=>{
   const mobile=!!header&&window.matchMedia('(max-width:800px)').matches;
   const anchor=mobile?(document.querySelector('.restored-hero-copy>.restored-eyebrow')||header):null;
   if(currentAnchor!==anchor){
    if(anchor===header)header.after(space,bar);
    else if(anchor){header.after(bar);anchor.after(space);}
    else{parent.insertBefore(space,next);parent.insertBefore(bar,next);}
    currentAnchor=anchor;
   }
   space.style.height=Math.ceil(bar.getBoundingClientRect().height)+'px';
   bar.style.top=anchor?Math.max(0,Math.ceil(anchor.getBoundingClientRect().bottom))+'px':'';
  };
  const observer=typeof ResizeObserver==='function'?new ResizeObserver(update):null;
  observer?.observe(bar);if(header)observer?.observe(header);const opening=document.querySelector('.restored-hero');if(opening)observer?.observe(opening);
  window.addEventListener('resize',update);
  window.addEventListener('scroll',update,{passive:true});
  active={bar,space,parent,next,update,observer};update();
  document.fonts?.ready.then(()=>{if(active?.bar===bar)update();});
 }
 window.ATELIER_COLLECTION_BAR={mount};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
 document.addEventListener('shopify:section:load',()=>mount(document));
 document.addEventListener('shopify:section:unload',event=>{if(active&&event.target.contains(active.bar))cleanup();});
})();
